export const ENTITY_TYPES = {
  adminEvent: 'admin_event',
  company: 'company',
  customPage: 'custom_page',
  forumDiscussion: 'forum_discussion',
  group: 'group',
  mediaCenterFile: 'media_center_file',
  mediaCenterFolder: 'media_center_folder',
  news: 'news',
  opportunity: 'opportunity',
  portfolioFile: 'portfolio_file',
  portfolioFolder: 'portfolio_folder',
  post: 'post',
  project: 'project',
  user: 'user',
  userEvent: 'user_event',
} as const;

export const LEGACY_ENTITY_TYPES = {
  adminEvent: 'network_event',
  opportunity: 'business_opportunity',
  post: 'feed_post',
} as const;
